import React from 'react';
import PropTypes from 'prop-types';

import content from 'assets/content/home.content.json';

import ImageGroup from 'assets/images/general/get-in-touch-images.png';

import './GetInTouch.scss';

GetInTouch.propTypes = {
    isMobile: PropTypes.bool
};

export default function GetInTouch({ isMobile }) {
    return (
        <section className='getInTouch'>
            <div className='getInTouch__container'>
                <img src={ImageGroup} alt='Get in touch' />
                <div>
                    <p className='getInTouch__title'>{`${content?.GET_IN_TOUCH.TITLE1} ${!isMobile ? '' : content?.GET_IN_TOUCH.TITLE2}`}</p>
                    {!isMobile && <p className='getInTouch__desc' dangerouslySetInnerHTML={{ __html: content?.GET_IN_TOUCH.TITLE }} />}
                </div>
                <a className='getInTouch__btn' href='https://wa.me/6581688604' target='_new'>{content?.GET_IN_TOUCH.GET_IN_TOUCH}</a>
            </div>
        </section>
    );
}
